module.exports = __webpack_public_path__ + "img/home.2b67699f.jpg";